import { updateItems } from '@/mocks/homeData';

export default function Updates() {
  return (
    <section id="updates" className="w-full bg-background-50 py-14 md:py-20">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">最新动态</h2>
          <p className="text-sm text-foreground-500">平台更新与内容上线快讯</p>
        </div>

        <div className="max-w-3xl mx-auto">
          {updateItems.map((item, idx) => (
            <div key={item.id} className="flex gap-4 md:gap-5">
              <div className="flex flex-col items-center flex-shrink-0">
                <div className={`w-2.5 h-2.5 rounded-full mt-1.5 ${
                  idx === 0 ? 'bg-accent-500 ring-4 ring-accent-100' : 'bg-background-300'
                }`}></div>
                {idx < updateItems.length - 1 && <div className="w-px flex-1 bg-background-200 my-1"></div>}
              </div>
              <div className={`pb-6 ${idx === updateItems.length - 1 ? 'pb-0' : ''}`}>
                <div className="text-xs text-foreground-400 mb-1">{item.date}</div>
                <h3 className="text-sm font-medium text-foreground-900 mb-1">{item.title}</h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}